/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Cookies from "universal-cookie";
import { ADMIN_API, USER_API } from "../common/common";
import { getImageUrl, Logout } from "../common/Funcation";
import {
  getTheme,
  styleObjectGetBG,
  styleObjectGetBGasColor,
  styleObjectGetBorderColor,
  styleObjectGetColor,
} from "../common/StyleSeter";
import { Helmet } from "react-helmet";

import Login from "../pages/Login";
import {
  getApi,
  getApiLink,
  notifyError,
  notifyMessage,
  postApi,
  sendEvent,
} from "../service";
import StakePopup from "./StakePopup";
import BetBox from "../pages/MultiMarket/BetBox";
import transparent from "../assets/images/transparent.gif";
import yelloImage from "../assets/images/s-yellow.svg";
import { isMobile } from "react-device-detect";

const cookies = new Cookies();

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const homeData = useSelector((e: any) => e.homeData);
  const HeaderData = useSelector((e: any) => e.Header);
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const marketListDetails = useSelector((e: any) => e.marketListDetails);
  const [searchEvent, setSearchEvent] = useState<any>({
    searchText: "",
    typing: false,
    typingTimeout: undefined,
  });
  const [showBetBox, setShowBetBox] = useState(false);
  const [searchData, setSearchData] = useState<any>();
  const balanceData = useSelector((e: any) => e.balance);
  const exposureData = useSelector((e: any) => e.exposure);
  const DD = useSelector((e: any) => e.domainDetails);
  const [domainDetails, setDomainDetails] = useState(DD);
  const [balance, setBalance] = useState(balanceData);
  const [exposures, setExposure] = useState(exposureData);
  const [headerOptions, setHeaderOptions] = useState(HeaderData);
  const [OpenModal, setOpenModal] = useState<boolean>(false);
  const [manageStack, setManageStack] = useState<any>();
  const matchCount = useSelector((e: any) => e.matchCount);
  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    validationCode: "",
  });
  const [headerOption, setHeaderOption] = useState([
    { name: "Home", hasAccess: true, link: "/", subOption: [] },
    { name: "InPlay ", hasAccess: true, link: "/in-play", subOption: [] },
    {
      name: "Multi Markets",
      hasAccess: true,
      link: "/multimarket",
      subOption: [],
    },
    { name: "Cricket", hasAccess: true, link: "/cricket", subOption: [] },
    { name: "Soccer", hasAccess: true, link: "/soccer", subOption: [] },
    { name: "Tennis", hasAccess: true, link: "/tennis", subOption: [] },
    { name: "Casino", hasAccess: true, link: "", subOption: [] },
  ]);
  const [showPass, setShowPass] = useState(false);

  useEffect(() => {
    if (marketListDetails?.data?.length > 0) {
      let HEADER_OPTIONS = [...headerOption];
      HEADER_OPTIONS.forEach((element: any) => {
        marketListDetails.data.forEach((item: any) => {
          if (item?.name === element?.name) {
            element.hasAccess = !item.isBlock;
          }
        });
      });
      setHeaderOption([...HEADER_OPTIONS]);
    }
    return () => {};
  }, [marketListDetails]);

  const [openMenu, setOpenMenu] = useState(false);
  const [isLoadding, setIsLoadding] = useState(true);
  const [searchString, setSearchString] = useState("");
  const [oneClickActive, setOneClickActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [OpenSetting, setOpenSetting] = useState(false);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [confirmationCode, setConfirmationCode] = useState(
    Math.floor(1000 + Math.random() * 9000)
  );
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const isCaptcha = process.env.REACT_APP_CAPTCHA;

  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };
  const handelSubmit = async (e: any) => {
    e.preventDefault();

    if (
      Validator.current.allValid() &&
      (confirmationCode === parseInt(formData.validationCode) ||
        isCaptcha === "false")
    ) {
      setIsValidationWrong(false);
      const ipDetails = await getApiLink({
        api: "https://ipapi.co/json/?key=wfzfdfQ4cUsaTVURUkj2oF6L51Y4jNE0IM2yE0V2xMyMkxjTsr",
      });
      console.log("call ip:  ipDetails :", ipDetails);

      let data = {
        api: USER_API.LOGIN,
        value: {
          user_name: formData.user_name,
          password: formData.password,
          domain: window.location.hostname,
          city: ipDetails?.data?.city,
          state: ipDetails?.data?.region,
          country: ipDetails?.data?.country_name,
          ISP: ipDetails?.data?.org
        },
      };
      setIsLoadding(true);
      await postApi(data)
        .then(function (loginData) {
          if (loginData) {
            // notifyMessage(loginData.data.message)

            let HeaderData = {
              ...loginData.data.data.roleAccess,
              user_name: loginData.data.data.user_name,
              remaining_balance: loginData.data.data?.balance,
              exposure: loginData.data.data?.exposure,
              ...loginData.data.data,
            };
            dispatch({ type: "HEADER_DETAILS", payload: HeaderData });
            cookies.set("skyTokenFront", loginData.data.data.token, {
              domain: process.env.REACT_APP_COOKIE_DOMAIN,
              path: "/",
            });
            dispatch({
              type: "AUTHENTICATION",
              payload: {
                isLogin: true,
                token: loginData.data.data.token,
                changePassword: loginData.data.data.newPassword,
              },
            });
            setOpenModal(false);
            if (loginData.data.data.newPassword) {
              navigate("change/password");
            }
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        })
        .catch((err) => {
          setIsLoadding(false);
          notifyError(err.response.data.message);
          setIsValidationWrong(false);
          setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
          setFormData({ ...formData, validationCode: "" });
        });
    } else {
      Validator.current.showMessages();
      if (confirmationCode !== parseInt(formData.validationCode)) {
        setIsValidationWrong(true);
      }
      setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
      forceUpdate();
    }
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    })
  );

  useEffect(() => {
    setBalance(balanceData);

    return () => {};
  }, [balanceData]);
  useEffect(() => {
    setExposure(exposureData);
    return () => {};
  }, [exposureData]);

  useEffect(() => {
    if (balanceData !== "" && exposureData !== "") {
      setIsLoadding(false);
    }
  }, [balanceData, exposureData]);

  useEffect(() => {
    if (cookies.get('skyTokenFront')){
      setIsLoadding(false);
    }
    setHeaderOptions(HeaderData);
    return () => {};
  }, [HeaderData]);

  useEffect(() => {
    setDomainDetails(DD);
    return () => {};
  }, [DD]);

  useEffect(() => {
    if (HeaderData) {
      setTimeout(() => {
        sendEvent("UPDATE_USER_BALANCE", { userId: HeaderData?._id });
      }, 1000);
    }
    if (matchCount) {
      setInterval(() => {
        sendEvent("GET_LIVE_MATCH_COUNT_FOR_VELKI", {});
      }, 10000);
    }
    return () => {};
  }, []);

  const HandleNavigation = (path: string) => {
    navigate(path);
  };

  const HandleLogOut = (e: any) => {
    e.preventDefault();
    Logout(e);
    dispatch({
      type: "AUTHENTICATION",
      payload: { isLogin: false, token: "", changePassword: false },
    });
    navigate("/login");
  };

  const items = [
    { id: 0, name: "Cobol" },
    { id: 1, name: "JavaScript" },
    { id: 2, name: "Basic" },
    { id: 3, name: "PHP" },
    { id: 4, name: "Java" },
  ];

  const getInPlayData = async (FILTER: string) => {
    // setIsLoading(true)

    let data = {
      api: USER_API.IN_PLAY,
      value: { filter: FILTER },
    };

    await postApi(data)
      .then(function (response) {
        if (FILTER === "play") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_IN_PLAY",
            payload: response.data.data,
          });
        } else if (FILTER === "today") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TODAY",
            payload: response.data.data,
          });
        } else if (FILTER === "tomorrow") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TOMORROW",
            payload: response.data.data,
          });
        } else {
          dispatch({ type: "SET_IN_PLAY_DETAILS", payload: undefined });
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  useEffect(() => {
    setTimeout(() => {
      sendEvent("GET_SPORTS", { type: "cricket" });
      sendEvent("GET_SPORTS", { type: "tennis" });
      sendEvent("GET_SPORTS", { type: "soccer" });
    }, 5000);
    setTimeout(() => {
      getInPlayData("play");
      getInPlayData("today");
      getInPlayData("tomorrow");
    }, 3300);
  }, []);

  const [currentBetCount, setCurrentBetCount] = useState();
  useEffect(() => {
    if (cookies.get("skyTokenFront")) {
      // setInterval(() => {
      getBetCount();
      // }, 2000);
    }
  }, []);

  const getBetCount = async () => {
    let data = {
      api: USER_API.BET_LIST,
      value: {},
    };
    await postApi(data)
      .then(function (response) {
        setCurrentBetCount(response.data.data.length);
      })
      .catch((err) => {
        if (err.response.data.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  return (
    <>
      {window.innerWidth < 993 && showBetBox && (
        <div>
          {" "}
          <BetBox isMobile={true} betHistoryShow={showBetBox} />{" "}
        </div>
      )}

      <header className="header">
        <Helmet>
          <link rel="icon" href={getImageUrl(domainDetails?.favicon)} />
          <title>{domainDetails?.title}</title>
        </Helmet>
        <div className="header_wrp" style={styleObjectGetBG(domainDetails?.colorSchema)}>
          <div className="header_wrp_l">
            {window.location.pathname.split("/")[1] === "multimarket" ? (
              <span className="menu-btn" onClick={() => navigate("sports")}>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  className="fs-4"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"></path>
                </svg>
              </span>
            ) : (
              cookies.get("skyTokenFront") && (
                <span
                  className="menu-btn"
                  onClick={() => setOpenMenu(!openMenu)}
                >
                  {/* <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="fs-4" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"></path></svg> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4 6H20M4 12H20M4 18H20"
                      stroke="#000000"
                      stroke-width="2.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              )
            )}

            <div className="header_wrp_l_logo c">
              <a href="/">
                <img src={getImageUrl(domainDetails?.logo)} alt="logo" />
              </a>
            </div>
          </div>

          <div className="header_wrp_r">
            {!isAuthenticated && !cookies.get("skyTokenFront") ? (
              <>
                <ul className="login-wrap d_flex mobile_login ">
                  {homeData?.signup === true && (
                    // <li>
                    //     <a className="btn-signup" href={domainDetails?.agentListUrl} target='_blank'>Sign-Up</a>
                    // </li>
                    <li>
                      <a
                        className="btn-signup-new"
                        href={domainDetails?.agentListUrl}
                        target="_blank"
                      >
                        <img
                          src="data:image/png;base64,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"
                          alt=""
                        />
                        Sign-Up
                      </a>
                    </li>
                  )}
                  <li>
                    <a id="loginBtn" href="/login" className="btn-login">
                      <img
                        src="data:image/png;base64,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"
                        alt=""
                      />
                      Login
                    </a>
                  </li>
                </ul>
              </>
            ) : (
              <ul className="account-wrap">
                <li className="main-wallet">
                  <a id="multiWallet" className="a-wallet">
                    <ul id="accountCredit d_flex">
                      {!isLoadding ? (
                        <>
                          <li style={domainDetails?.colorSchema === 'yellow' ? { } : {color: "#ffffff"}}>
                            <span>{HeaderData.user_name}</span>
                          </li>
                          <li
                            style={styleObjectGetBGasColor(
                              domainDetails?.colorSchema
                            )}
                          >
                            <span style={domainDetails?.colorSchema === 'yellow' ? { color: "#00000063" } : {color:"#ffffff"}}>
                              {domainDetails?.currency
                                ? domainDetails?.currency
                                : "PTH"}{" "}
                            </span>
                            <span
                              style={domainDetails?.colorSchema === 'yellow' ? { fontWeight: "bolder", color: "#000000" } : { fontWeight: "bolder", color:"#ffffff"}}
                              id="betCredit"
                            >
                              {balance}
                            </span>
                            <span style={domainDetails?.colorSchema === 'yellow' ? { color: "#00000063" } : {color:"#ffffff"}}> Exp </span>
                            <span
                              style={{ color: "#ffffff", background: "red" }}
                              id="totalExposure"
                            >
                              ({exposures})
                            </span>
                          </li>
                        </>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="100px"
                          height="40px"
                          viewBox="0 0 100 100"
                          preserveAspectRatio="xMidYMid"
                        >
                          <g transform="translate(20 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="-0.375s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                          <g transform="translate(40 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="-0.25s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                          <g transform="translate(60 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="-0.125s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                          <g transform="translate(80 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="0s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                        </svg>
                      )}
                    </ul>
                    <div onClick={() => window.location.reload()}>
                      <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        height="20"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeWidth={"2.2px"}
                          strokeLinejoin="round"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </li>
              </ul>
            )}
          </div>
        </div>

        {openMenu && (
          <div>
            <div className="sidebar-wrapper">
              <div className="top-sidebar mb-3 ps-1 d-flex justify-content-between">
                <strong>Menu</strong>
                <button
                  className="bg-transparent border-0 p-0"
                  onClick={() => setOpenMenu(!openMenu)}
                >
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="0"
                    viewBox="0 0 15 15"
                    height="20px"
                    width="20px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </button>
              </div>
              <ul className="p-0 m-0 mb-3">
                <li>
                  <a className="text-decoration-none" href="/balance-overview">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"></path>
                    </svg>
                    <span>Balance Overview</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/account-statement">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z"></path>
                      <path d="M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"></path>
                    </svg>{" "}
                    <span>Account Statement</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/current-bets">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h15v3h-6c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h6.001v3H5zm15-9v4h-6v-4h6z"></path>
                    </svg>{" "}
                    <span>Current Bets</span>{" "}
                    <strong className="rounded-count ms-2 bg-yellow d-block p-2 py-0 fs-6 rounded text-white">
                      {currentBetCount}
                    </strong>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/bets-history">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                    </svg>{" "}
                    <span>Bets History</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/profit-and-loss">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 1024 1024"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"></path>
                    </svg>{" "}
                    <span>Profit &amp; Loss</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/active-log">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13 12.8293C14.1652 12.4175 15 11.3062 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.3062 9.83481 12.4175 11 12.8293V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12.8293ZM11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10Z"
                        fill="currentColor"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                        fill="currentColor"
                      ></path>
                    </svg>{" "}
                    <span>Active Log</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/my-profile">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 448 512"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"></path>
                    </svg>{" "}
                    <span>My Profile</span>
                  </a>
                </li>
              </ul>
              <ul className="p-0 m-0 mb-3">
                <li>
                  <a className="text-decoration-none" href="/p2p-transfer">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m15 12 5-4-5-4v2.999H2v2h13zm7 3H9v-3l-5 4 5 4v-3h13z"></path>
                    </svg>{" "}
                    <span>P2P Transfer</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/p2p-transfer-log">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 18v3h16v-14l-8 -4l-8 4v3"></path>
                      <path d="M4 14h9"></path>
                      <path d="M10 11l3 3l-3 3"></path>
                    </svg>{" "}
                    <span>P2P Transfer log</span>
                  </a>
                </li>
              </ul>
              <ul className="p-0 m-0 mb-3">
                <li>
                  <a className="text-decoration-none" href="/setting">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M413.967 276.8c1.06-6.235 1.06-13.518 1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318c4.26-3.118 5.319-8.317 2.13-13.518L418.215 115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186 20.801c-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098c-5.318 0-9.577 4.164-10.637 8.318l-8.508 55.117c-12.767 5.2-24.464 12.482-36.171 20.801l-53.186-20.801c-5.319-2.071-10.638 0-12.767 4.164L49.1 187.365c-2.119 4.153-1.061 10.399 2.129 13.518L96.97 235.2c0 7.282-1.06 13.518-1.06 20.8s1.06 13.518 1.06 20.8l-44.668 34.318c-4.26 3.118-5.318 8.317-2.13 13.518L92.721 396.4c2.13 4.164 8.508 6.235 12.767 4.164l53.187-20.801c10.637 8.318 23.394 15.601 36.16 20.801l8.508 55.117c1.069 5.2 5.318 8.318 10.637 8.318h85.098c5.319 0 9.578-4.164 10.638-8.318l8.518-55.117c12.757-5.2 24.464-12.482 36.16-20.801l53.187 20.801c5.318 2.071 10.637 0 12.767-4.164l42.549-71.765c2.129-4.153 1.06-10.399-2.13-13.518l-46.8-34.317zm-158.499 52c-41.489 0-74.46-32.235-74.46-72.8s32.971-72.8 74.46-72.8 74.461 32.235 74.461 72.8-32.972 72.8-74.461 72.8z"></path>
                    </svg>
                    <span>Setting</span>
                  </a>
                </li>
              </ul>
              <button
                className="logout-button"
                onClick={(e) => HandleLogOut(e)}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  className="me-2"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m2 12 5 4v-3h9v-2H7V8z"></path>
                  <path d="M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051 2.051 3.08 2.051 4.95-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"></path>
                </svg>
                Logout
              </button>
              <div className="time-zone text-center pt-4">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 1024 1024"
                  className="me-2 fs-4"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"></path>
                </svg>
                <span>Time Zone：GMT+6:00</span>
              </div>
            </div>
            <div
              className="overlay"
              onClick={() => setOpenMenu(!openMenu)}
            ></div>
          </div>
        )}

        {/* <div className="menu_part" style={styleObjectGetBG(domainDetails?.colorSchema)}>
                    <ul>
                        {headerOption.map((item, i) => {
                            if (!item.hasAccess) return false
                            if (item.name === "Casino" && !cookies.get('skyTokenFront')) return false
                            return (
                                <li key={i} >
                                    {["Cricket", "Soccer", "Tennis"].includes(item.name) ? <Link style={styleObjectGetColor(domainDetails?.colorSchema)} className={`${item.subOption.length > 0 ? "menu-drop" : ''} ${(window.location.pathname === item.link) ? 'selected' : ''}`} to={item.link}>
                                        {item.name}
                                        {item.name === "Cricket" && matchCount && <span id="tagLive" className="tag-live"><strong></strong>{matchCount.cricket}</span>}
                                        {item.name === "Soccer" && matchCount && <span id="tagLive" className="tag-live"><strong></strong>{matchCount.soccer}</span>}
                                        {item.name === "Tennis" && matchCount && <span id="tagLive" className="tag-live"><strong></strong>{matchCount.tennis}</span>}
                                        {item.name === "E-Soccer" && <span id="tagLive" className="tag-live"><strong></strong>5</span>}
                                        {item.name === "Kabaddi" && <span id="tagLive" className="tag-live"><strong></strong>0</span>}
                                    </Link> : item.name === "Casino" && cookies.get('skyTokenFront') ? <a style={styleObjectGetColor(domainDetails?.colorSchema)} className={`${item.subOption.length > 0 ? "menu-drop" : ''} ${(window.location.pathname === item.link) ? 'selected' : ''} ${item.name === "Casino" ? "casino_class" : ''}`}
                                        onClick={() => getCasinoLink()}>
                                        {item.name}
                                        {item.name === "Casino" ? <img style={{ width: "20px" }} src="/images/card-game.svg" /> : ''}
                                    </a> : <a style={styleObjectGetColor(domainDetails?.colorSchema)} className={`${item.subOption.length > 0 ? "menu-drop" : ''} ${(window.location.pathname === item.link) ? 'selected' : ''}`}
                                        href={item.link}>
                                        {item.name}
                                    </a>}
                                </li>)

                        })}

                    </ul>

                    <ul className='setting-wrap'>
                        <li className="time_zone"><span>Time Zone :</span> GMT+5:30</li>
                        <li >
                            <a id="oneClickSetting" className={`one_click ${oneClickActive ? 'active' : ''}`} style={styleObjectGetBGasColor(domainDetails?.colorSchema, true)}> <input type="checkbox" name="" id="" style={{ margin: 0 }} /> One Click Bet </a>
                        </li>
                        <li><a id="slipSet" className="setting" onClick={() => handleSetting()}>Setting <img src="/images/setting.svg" /></a></li>
                    </ul>

                </div> */}

        {/* <div className="mobilemenu">
                    <nav>
                        <ul>
                            <li id="mini" className="game-nav">
                                <a onClick={() => getCasinoLink(true)} className="ui-link">
                                    <img className="icon-promote" src="/images/promot.gif" alt="mini" />
                                </a>
                            </li>
                            <li className={['/cricket', '/soccer', '/tennis'].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <Link className="" to="/cricket">
                                    <img className="icon-sports" src="/images/Sports.svg" alt="Sports" />
                                    Sports
                                </Link>
                            </li>
                            <li className={['/in-play'].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <Link className="" to="/in-play">
                                    <img className="icon-inplay" src="/images/menu-In-Plan.svg" alt="In-Play" />
                                    In-Play
                                </Link>
                            </li>
                            <li className={window.location.pathname === '/' || window.location.pathname === '/#' ? "main-nav select" : ''}>
                                <a className="" href="/">
                                    <img className="icon-home" src="/images/Home.svg" alt="Home" />
                                    Home
                                </a>
                            </li>
                            <li className={['/multimarket',].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <a className="multi_market" href="/multimarket">
                                    <img className="icon-pin" src="/images/Multi-Markets.svg" alt="Multi Markets" />
                                    Multi Markets
                                </a>
                            </li>
                            <li className={['/myAccount', '/user'].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <a href="/myAccount" data-bs-toggle="modal" data-bs-target="#myLoginModalFront">
                                    <img className="icon-account" src="/images/Account.svg" alt="Account" />
                                    Account
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div> */}
      </header>

      {OpenModal && (
        <div
          className={`login popup-wrp fade ${OpenModal ? "popup-show " : ""}`}
        >
          <div className="pop">
            <div className="pop-content">
              <div className="pop-head">
                <div
                  className="pop-close"
                  onClick={() => setOpenModal(true)}
                ></div>
              </div>
              <div className="pop-body">
                <Login OpenModal={OpenModal} setOpenModal={setOpenModal} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
